import styles from "./summaryContainer.module.css";

const DEFAULT_CLASSES = {
  container: styles.container,
  header: styles.header,
  title: styles.title,
  titleIcon: styles.titleIcon,
  content: styles.content,
  actionButton: styles.actionButton,
  actionButtonIcon: styles.actionButtonIcon,
};

export default function SummaryContainer({
  title = "",
  titleIcon = null,
  onAction = () => {},
  actionButtonTitle = "",
  actionButtonIcon = null,
  disabled = false,
  cartSummaryClassesOverride = {},
  cartSummaryStyles = {},
  children,
  error = null
}) {
  const classes = { ...DEFAULT_CLASSES, ...cartSummaryClassesOverride };

  return (
    <aside className={classes.container} style={cartSummaryStyles.container}>
      {(title || titleIcon) && (
        <div className={classes.header} style={cartSummaryStyles.header}>
          {title ? <h2 className={classes.title} style={cartSummaryStyles.title}>{title}</h2> : null}
          {titleIcon ? (
            <div className={classes.titleIcon} style={cartSummaryStyles.titleIcon}>{titleIcon}</div>
          ) : null}
        </div>
      )}

      {children ? (
        <div className={classes.content} style={cartSummaryStyles.content}>{children}</div>
      ) : null}

      {actionButtonTitle ? (
        <button
          type="button"
          className={classes.actionButton}
          style={cartSummaryStyles.actionButton}
          onClick={onAction}
          disabled={disabled}
        >
          <span>{actionButtonTitle}</span>
          {actionButtonIcon ? (
            <span
              className={classes.actionButtonIcon}
              style={cartSummaryStyles.actionButtonIcon}
            >
              {actionButtonIcon}
            </span>
          ) : null}
        </button>
      ) : null}
      {error ? (
        <p className={styles.errorMessage} style={cartSummaryStyles.errorMessage}>{error}</p>
      ) : null}
    </aside>
  );
}
